import { useModulePermission } from '../../../hooks/usePermission';
import { Modules } from '../../../constants/permissions';

/**
 * P930H module permission hook
 * pgCode = "pw930hf1"
 */
export function useP930HPermissions() {
  return useModulePermission(Modules.P930H);
}
